// src/utils/api.js
import { getFirebaseToken } from "../authService";

/**
 * Función helper para hacer peticiones autenticadas al backend
 * Automáticamente incluye el token de Firebase en el header Authorization
 * 
 * @param {string} endpoint - El endpoint relativo (ej: '/datos-profesional')
 * @param {object} options - Opciones de fetch (method, body, headers, etc.)
 * @returns {Promise<Response>} - La respuesta de fetch
 */
export async function apiRequest(endpoint, options = {}) {
  const baseURL = process.env.REACT_APP_BACKEND_BASE_URL || 
                  process.env.REACT_APP_API_URL || 
                  process.env.REACT_APP_BASE_URL;
  
  if (!baseURL) {
    throw new Error("No se encontró la URL base del backend en las variables de entorno");
  }

  // Obtener el token de Firebase
  const token = await getFirebaseToken();
  
  // Construir la URL completa
  const url = endpoint.startsWith('http') ? endpoint : `${baseURL}${endpoint}`;
  
  // Preparar headers
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };
  
  // Agregar token de autenticación si está disponible
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  // Realizar la petición
  const response = await fetch(url, {
    ...options,
    headers,
  });
  
  return response;
}

